import React from "react";
import {HelpDirectoryRepository} from "../../../repository";
import {HelpDirectory} from "../../../model";
import {EntityFormTemplate} from "../../../component/template/EntityFormTemplate";
import * as Yup from "yup";

export const UpdateHelpDirectory = () => {

    return (
        <EntityFormTemplate<HelpDirectory>
            mode={'update'}
            repository={new HelpDirectoryRepository()}
            title={{
                page: `Répertoire (Aide en ligne)`,
                schema: `Modifier le répertoire "$0"`,
                params: [`name`]
            }}
            fields= {[
                { label: `Nom`, id: 'name', type: 'text' },
            ]}
            validationSchema={
                Yup.object().shape({
                    name: Yup.string()
                        .min(3, 'Minimum 3 caractères.')
                        .max(200, 'Maximum 200 caractères.')
                        .required('Obligatoire'),
                })
            }
        />
    )
}